import "./LanguageSelector.css";

export const LanguageSelector = ({ language, handleLanguageChange }) => {
  return (
    <div className="language-selector">
      <button onClick={() => handleLanguageChange("pt-br")}>
        <img
          className={
            language === "pt-br" ? "language-active" : "language-unactive"
          }
          src="https://flagsapi.com/BR/flat/64.png"
          alt="Bandeira do Brasil, seleciona o idioma em Português"
        />
      </button>
      <button onClick={() => handleLanguageChange("en")}>
        <img
          className={
            language === "en" ? "language-active" : "language-unactive"
          }
          src="https://flagsapi.com/US/flat/64.png"
          alt="Flag of the United States of America, select the English language"
        />
      </button>
      <button onClick={() => handleLanguageChange("es")}>
        <img
          className={
            language === "es" ? "language-active" : "language-unactive"
          }
          src="https://flagsapi.com/ES/flat/64.png"
          alt="Bandera de España, selecciona el idioma español"
        />
      </button>
    </div>
  );
};
